export const MUNE_DATA = {
    name: 'Leopold',
    mail: 'alex696@madeindalls.com',
    account: '0x8a33...Odeb',
}

export type UserInfoType = {
    name: string,
    mail: string,
    account: string,
}